import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Bio } from './components/Bio';
import { Curriculum } from './components/Curriculum';
import { Pricing } from './components/Pricing';
import { TaglineBanner } from './components/TaglineBanner';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="3fb19frelong4">
      <AnnouncementBar data-id="element-1" data-mp="2rloz2o7je9c8" />
      <main data-id="element-2" data-mp="2rl6xrd60p4xg">
        <Hero data-id="element-3" data-mp="2riknh5rqsbbj" />
        <Bio data-id="element-4" data-mp="2mm2mmgzj8x4h" />
        <Curriculum data-id="element-5" data-mp="2mmcbu2cr7094" />
        <Pricing data-id="element-6" data-mp="2mmvob3jmwwfr" />
        <TaglineBanner data-id="element-7" data-mp="2mndna7xolord" />
      </main>
    </div>;
}